import React from 'react'
import { useHistory } from 'react-router-dom'

const HistoryBack: React.FC = ({}) => {
  const history = useHistory()

  return (
    <button
      onClick={() => {
        history.go(-1)
      }}
      className="main-content-back"
    >
      <span className="far fa-chevron-left" />
    </button>
  )
}

export default HistoryBack
